import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'emailHide'
})
export class EmailHidePipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return '';
        
        const atIndex = value.indexOf('@');
        if (atIndex > 0) {
            const hiddenPart = '*'.repeat(atIndex);
            return hiddenPart + value.substring(atIndex);
        } else {
            return value;
        }
    }
}